import { Component, OnInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../../core/navigation.service';
import { LeftPanelService } from '../../../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../../../../shared/components/datepicker/datepicker-config.service';
import { ChannelTransferDataEditorService } from '../../services/channel-transfer-data-editor.service';
import { ChannelTransferDataService } from '../../services/channel-transfer-data.service';

@Component({
  selector: 'lfwms-channel-transfer-primary-accordion',
  templateUrl: './channel-transfer-primary-accordian.component.html',
  styleUrls: ['./channel-transfer-primary-accordian.component.css']
})
export class ChannelTransferPrimaryAccordianComponent extends AbstractFormWidgetComponent implements OnInit {
  public dataEditor: ChannelTransferDataEditorService;
  public dataService: ChannelTransferDataService;

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
  }

  public setPrimeFocus(row: any, property: any) {
      this.keyEventHandler.setFocusedCell(row, property);
  }
  
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/channel-inventory-management/channel-transfer/channel-transfer-home/channel-transfer-primary-accordian/channel-transfer-primary-accordian.component.ts